/* eslint-disable sort-keys */
import { RegistrationAddressT } from './address';

export const MARITAL_STATUS_OPTIONS = {
  single: 'Single',
  married: 'Married',
  legally_separated: 'Legally separated',
  divorced: 'Divorced',
} as const;
/* eslint-enable sort-keys */

export type MaritalStatusValueT = keyof typeof MARITAL_STATUS_OPTIONS;

export const marriedStatuses: MaritalStatusValueT[] = ['married', 'legally_separated'];

export type MaritalStatusOptionT = {
    label: string;
    value: MaritalStatusValueT;
};

export const maritalStatusOptions: MaritalStatusOptionT[] = (Object
  .entries(MARITAL_STATUS_OPTIONS) as [MaritalStatusValueT, string][])
  .map(([value, label]) => ({ label, value }));

export type MaritalInformationSpouseT = {
  firstName: string;
  lastName: string;
  sameAddress: boolean;
  address?: RegistrationAddressT;
};

export type MaritalInformationFormT = {
  maritalStatus: MaritalStatusValueT;
  spouse?: MaritalInformationSpouseT;
};
